// React imports.
import React from "react";

//app imports
import { Assessment1FuelStatusEnum } from "../state";



const Assessment1MainTableRow = ({ state, fuel, step, fieldChangeHandler, rowClass }) => (
  <React.Fragment>


    
    <div className={"dwGridRow col1 " + rowClass} >{fuel.description}</div>
    {step.showComputedAverageExpenditure === true &&
      <div className={"dwGridRow  col2 blue-background " + rowClass}>
        <input id="computedAverageExpenditure" value={fuel.computedAverageExpenditure}
          onChange={(changeEvent) => fieldChangeHandler(changeEvent, fuel)}
          className="form-control " />
      </div>
    }
    {step.showSedsAverageExpenditure === true &&
      <div className={"dwGridRow  col3 orange-background " + rowClass} >
        {(fuel.sedsMainHeatCode === state.SEDS_DATA_OK
          || fuel.sedsMainHeatCode === state.SEDS_PM_DATA_BAD
          || fuel.sedsMainHeatCode === state.SEDS_PM_DATA_ZERO_REP)
          && <span>${fuel.sedsAverageExpenditure.toLocaleString()}</span>
        }
        {(fuel.sedsMainHeatCode !== state.SEDS_DATA_OK
          && fuel.sedsMainHeatCode !== state.SEDS_PM_DATA_BAD
          && fuel.sedsMainHeatCode !== state.SEDS_PM_DATA_ZERO_REP)
          &&
          <span>N/A</span>
        }
      </div>
    }

    {step.showPercentOfSedsString === true &&
      <React.Fragment>
        {(fuel.sedsMainHeatCode === state.SEDS_DATA_OK
          && (fuel.percentOfSedsStatus == Assessment1FuelStatusEnum.OverMax
            || fuel.percentOfSedsStatus == Assessment1FuelStatusEnum.UnderMin))
          &&
          <div className={"dwGridRow col4 red-background " + rowClass} >
            {fuel.percentOfSedsString}
          </div>
        }
        {(fuel.sedsMainHeatCode === state.SEDS_DATA_OK
          && fuel.percentOfSedsStatus != Assessment1FuelStatusEnum.OverMax
          && fuel.percentOfSedsStatus != Assessment1FuelStatusEnum.UnderMin)
          &&
          <div className={"dwGridRow col4 green-background " + rowClass} >{fuel.percentOfSedsString} </div>
        }
        {(fuel.sedsMainHeatCode !== state.SEDS_DATA_OK
          && fuel.sedsMainHeatCode !== state.SEDS_PM_DATA_BAD
          && fuel.sedsMainHeatCode !== state.SEDS_PM_DATA_ZERO_REP)
          &&
          <div className={"dwGridRow col4 " + rowClass} >N/A</div>
        }
        {(fuel.sedsMainHeatCode === state.SEDS_PM_DATA_BAD
          || fuel.sedsMainHeatCode === state.SEDS_PM_DATA_ZERO_REP)
          &&
          <div className={"dwGridRow col4 " + rowClass} >{fuel.percentOfSedsString} </div>
        }
      </React.Fragment>
    }

    {step.showPercentOfSedsStatus === true &&
      <React.Fragment>
        {(fuel.percentOfSedsStatus == Assessment1FuelStatusEnum.OverMax
          && fuel.sedsMainHeatCode === state.SEDS_DATA_OK)
          &&
          <div className={"dwGridRow col5 red-background " + rowClass} >
            <span>
              <strong>Potential Issue –</strong> The average main heating bill you reported is above
              the expected range for   {fuel.description}  households.
            </span>
          </div>
        }
        {(fuel.percentOfSedsStatus == Assessment1FuelStatusEnum.UnderMin
          && fuel.sedsMainHeatCode === state.SEDS_DATA_OK)
          &&
          <div className={"dwGridRow col5 red-background " + rowClass} >
            <span>
              <strong>Potential Issue –</strong> The average main heating bill you reported is below the expected
              range for   {fuel.description}  households.
            </span>
          </div>
        }
        {(fuel.percentOfSedsStatus == Assessment1FuelStatusEnum.ZeroAverageExpenditure
          && fuel.totalAssistedhHNum > 0
          && fuel.sedsMainHeatCode === state.SEDS_DATA_OK)
          &&
          <div className={"dwGridRow col5 red-background " + rowClass} >
            <span>
              <strong>Potential Issue –</strong> You did not report an average heating bill
              for  {fuel.description}  type even though your model plan indicates
              you serve households that heat with this fuel.
            </span>
          </div>
        }
        {(fuel.percentOfSedsStatus == Assessment1FuelStatusEnum.ZeroAverageExpenditure
          && (fuel.totalAssistedhHNum == 0 || fuel.totalAssistedhHNum == null)
          && fuel.sedsMainHeatCode === state.SEDS_DATA_OK)
          &&
          <div className={"dwGridRow col5 " + rowClass} >
            <strong>N/A –</strong> You indicated that you do not serve households that heat with   {fuel.description}.
          </div>
        }
        {(fuel.sedsMainHeatCode !== state.SEDS_DATA_OK)
          &&
          <div className={"dwGridRow col5 " + rowClass} >
            {state.SedsValueCodesAssociativeArray[fuel.sedsMainHeatCode]}
          </div>
        }
        {(fuel.percentOfSedsStatus != null
          && fuel.percentOfSedsStatus != Assessment1FuelStatusEnum.OverMax
          && fuel.percentOfSedsStatus != Assessment1FuelStatusEnum.UnderMin
          && fuel.percentOfSedsStatus != Assessment1FuelStatusEnum.ZeroAverageExpenditure
          && fuel.percentOfSedsStatus != Assessment1FuelStatusEnum.NoSEDSData
          && fuel.sedsMainHeatCode === state.SEDS_DATA_OK)
          &&
          <div className={"dwGridRow col5 green-background " + rowClass} >
            <span>
              <strong>No Issue Flagged –</strong> The average main heating bill you reported is within the expected
              range for    {fuel.description}  households.
            </span>
          </div>
        }
      </React.Fragment>
    }
  </React.Fragment>
);

export default Assessment1MainTableRow;
